import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface TabItem {
  key: string;
  label: ReactNode;
  disabled?: boolean;
  tone?: "budget";
}

/** Tablar -- segmentli tanlov ko'rinishida (redesign v2): faol tab ko'tarilgan oq/to'q bo'lak */
export function Tabs({ items, value, onChange, className }: { items: TabItem[]; value: string; onChange: (key: string) => void; className?: string }) {
  return (
    <div className={cn("inline-flex max-w-full flex-wrap gap-0.5 rounded-[12px] bg-fill p-[3px]", className)} role="tablist">
      {items.map((t) => {
        const active = t.key === value;
        return (
          <button
            key={t.key}
            role="tab"
            type="button"
            aria-selected={active}
            disabled={t.disabled}
            onClick={() => onChange(t.key)}
            className={cn(
              "inline-flex h-8 items-center gap-1.5 rounded-[9px] px-3.5 text-[13px] whitespace-nowrap transition-[background-color,color,box-shadow] duration-150",
              active ? "bg-raised font-semibold text-ink shadow-pill" : "font-medium text-muted hover:text-ink",
              t.disabled && "cursor-not-allowed opacity-50 hover:text-muted",
            )}
          >
            {t.tone === "budget" && <span className="inline-block h-1.5 w-1.5 rounded-full bg-budget" aria-hidden />}
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
